import { JURISDICTION_VALUES } from '../../consts'

const getJurisdictionCode = (patentNumber: string) => {
  const regex = /^[A-Z]{2}/
  const match = regex.exec(patentNumber)
  return match ? match[0] : ''
}

export const isInJurisdiction = (patentNumber: string) => {
  const code = getJurisdictionCode(patentNumber)
  return JURISDICTION_VALUES.includes(code)
}
